import { A11yCollapsibleCard } from '@wix/rules-panel-ui';
import React from 'react';
import { useA11yCardWrapper } from './use-a11y-card-wrapper';
export const A11yCardWrapper = /*#__PURE__*/React.memo(_ref => {
  let {
    cardTitle,
    pageIds,
    isCardOpen
  } = _ref;
  const {
    a11yCardProps,
    cardContent
  } = useA11yCardWrapper({
    cardTitle,
    isCardOpen,
    pageIds
  });
  return /*#__PURE__*/React.createElement(A11yCollapsibleCard, a11yCardProps, cardContent);
});
//# sourceMappingURL=a11y-card-wrapper.js.map